/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

export const styles = css`
  :host {
    display: none;
    height: 100%;
    min-width: 0;
    overflow: hidden;
  }

  :host([active]) {
    display: flex;
    flex: 1;
  }

  .panel {
    flex: 1;
    height: 100%;
    overflow: auto;
  }
`;

export default [styles];
